<template>
  <div class="logostyle"><h2> 4단 책장 </h2></div>

</template>

<script>
export default {

}
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&family=Noto+Sans+KR:wght@900&display=swap');

.logostyle {

  text-decoration:none;
  color:black;
  
}

 h2 { 
   
   font-size: 32px;

   font-family: 'Black Han Sans', sans-serif;

   font-weight: 500;
      
}

</style>